module.exports = __webpack_public_path__ + "media/images/location-b54dae2ac9e7b36431d681134c3fbffd.svg";